import { trackReplyTemplateEditSuccess } from '../../containers/ReplyTemplateModalContainer/tracking';
import { currentChatOpponentIdSelector, currentOpenChatIDSelector } from '../../selectors';
import { updateUserReplyTemplatePublic } from '../../services';
import { showAlert } from '../../slices/alertSlice';
import { createAppAsyncThunk } from '../../store/createAppAsyncThunk';
import { EAlert } from '../../types/alert';

import type { IUpdateUserReplyTemplateRequest, IUpdateUserReplyTemplateResponse } from '../../types/replyTemplates';

export const updateUserReplyTemplateThunk = createAppAsyncThunk<
  IUpdateUserReplyTemplateResponse,
  IUpdateUserReplyTemplateRequest,
  { rejectValue: string }
>('chats/updateUserReplyTemplateThunk', async (parameters: IUpdateUserReplyTemplateRequest, _thunkApi) => {
  const { fulfillWithValue, rejectWithValue, extra: context, dispatch, getState } = _thunkApi;

  const state = getState();

  try {
    const response = await updateUserReplyTemplatePublic(context, parameters);

    dispatch(showAlert({ message: 'Изменения сохранены!', type: EAlert.Info }));

    const opponentId = currentChatOpponentIdSelector(state);
    const chatId = currentOpenChatIDSelector(state);
    trackReplyTemplateEditSuccess({ chatId, opponentId, replyTemplateId: parameters.id });

    return fulfillWithValue(response);
  } catch (e) {
    dispatch(showAlert({ message: 'Не удалось сохранить изменения' }));

    if (e?.statusCode === 400) {
      return rejectWithValue(e instanceof Error ? e.message : String(e));
    }

    return rejectWithValue('');
  }
});
